export class FilterModel {

  FromDate: string;
  ToDate: string;

  maintenanceObjectNo?: string;
  createdBy?: string;
  taskCreated?: boolean;
  categoryNo?: number;

  constructor(fromDate: string, toDate: string, maintenanceObjectNo?: string, createdBy?: string, taskCreated?: boolean, categoryNo?: number) {
    this.FromDate = fromDate;
    this.ToDate = toDate;

    this.maintenanceObjectNo = maintenanceObjectNo;
    this.createdBy = createdBy;
    this.taskCreated = taskCreated;
    this.categoryNo = categoryNo;
  }
}

export enum DateRangeFilter {
  Week,
  FourteenDays ,
  Month,
  Quarter,
  Year
}




// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/FilterModel.ts